// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RZqTJBeYN7RXwcHgPFys {
  grid-area: page;
  height: 95%;
  display: grid;
  grid-template-columns: 1.6fr 3fr 3.2fr;
  grid-template-rows: 3% 1fr;
  background-color: var(--bg);
  border-radius: 2vmin;
}

.RZqTJBeYN7RXwcHgPFys aside {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 1.5vmin 2vmin;
}

.RZqTJBeYN7RXwcHgPFys nav {
  grid-column: 1/span 3;
  grid-row: 1;
  background-color: var(--tan-3);
  border-bottom-left-radius: 1vmin;
  border-bottom-right-radius: 1vmin;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/NewOrderPage/NewOrderPage.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,sCAAA;EACA,0BAAA;EACA,2BAAA;EACA,oBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,WAAA;EACA,8BAAA;EACA,gCAAA;EACA,iCAAA;EACA,SAAA;AACJ","sourcesContent":[".NewOrderPage {\n    grid-area: page;\n    height: 95%;\n    display: grid;\n    grid-template-columns: 1.6fr 3fr 3.2fr;\n    grid-template-rows: 3% 1fr;\n    background-color: var(--bg);\n    border-radius: 2vmin;\n}\n\n.NewOrderPage aside {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    margin: 1.5vmin 2vmin;\n}\n\n.NewOrderPage nav {\n    grid-column: 1 / span 3;\n    grid-row: 1;\n    background-color: var(--tan-3);\n    border-bottom-left-radius: 1vmin;\n    border-bottom-right-radius: 1vmin;\n    margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NewOrderPage": `RZqTJBeYN7RXwcHgPFys`
};
export default ___CSS_LOADER_EXPORT___;
